import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.submenuId = this.element.dataset.submenuId
    this.scrollTop = 0
    this.locked = false
  }

  open() {
    if (this.element.hasAttribute('is-open')) return

    this.dispatch('open', {
      prefix: 'submenu',
      target: window,
      detail: { id: this.submenuId },
    })

    this.locked = this.shouldLockScroll()
    if (this.locked) this.lockScroll()
    document.documentElement.classList.add('scroll-lock')
    this.element.setAttribute('is-open', 'true')
  }

  close(event) {
    if (event.detail.id !== this.submenuId || !this.element.hasAttribute('is-open')) return

    this.element.removeAttribute('is-open')
    if (this.locked) this.unlockScroll()
    document.documentElement.classList.remove('scroll-lock')
    this.locked = false
  }

  shouldLockScroll() {
    return document.body.classList.contains('iphone') && window.innerWidth < 1000
  }

  lockScroll() {
    this.scrollTop = window.scrollY || document.documentElement.scrollTop || 0
    document.body.style.top = `-${this.scrollTop}px`
}

  unlockScroll() {
    document.body.style.top = ''
    requestAnimationFrame(() => window.scrollTo(0, this.scrollTop))
  }
}
